import React from 'react';
import { Box, Drawer, IconButton, Tooltip, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { INK, LINE, MUTED } from './home/homeTheme';

// Pannello laterale "flottante" delle pagine V2 (Users, Customers): staccato dai bordi, angoli arrotondati e ombra,
// come la nuova sidebar. A tutta larghezza su mobile.
const PANEL_GAP = 12;
export const sidePanelPaperSx = {
  width: { xs: '100%', sm: 460 },
  p: 0,
  top: { sm: PANEL_GAP },
  right: { sm: PANEL_GAP },
  bottom: { sm: PANEL_GAP },
  height: { sm: 'auto' },
  borderRadius: { sm: '18px' },
  border: { sm: '1px solid' },
  borderColor: { sm: 'divider' },
  boxShadow: { sm: '0 24px 56px -16px rgba(15,23,18,0.35), 0 8px 20px rgba(15,23,18,0.12)' },
  overflow: 'hidden',
};
export const sidePanelBackdropSx = { bgcolor: 'rgba(0,0,0,0.18)' };

/** Sezione del pannello: titolo in maiuscoletto e contenuto, separata da una riga. */
export function PanelSection({ title, children }) {
  return (
    <Box sx={{ py: 1.75, borderTop: `1px solid ${LINE}` }}>
      <Typography sx={{ fontSize: 12, fontWeight: 700, color: MUTED, textTransform: 'uppercase', letterSpacing: '0.04em', mb: 1 }}>{title}</Typography>
      {children}
    </Box>
  );
}

/**
 * Pannello laterale completo: intestazione (icona, titolo, sottotitolo, azioni, chiudi),
 * corpo che scorre e, se presente, una barra di pulsanti in fondo.
 */
export default function SidePanel({ open, onClose, busy, icon, title, subtitle, actions, footer, children }) {
  return (
    <Drawer anchor="right" open={open} onClose={() => !busy && onClose()} PaperProps={{ sx: sidePanelPaperSx }} ModalProps={{ BackdropProps: { sx: sidePanelBackdropSx } }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2.5, pt: 2.5, pb: 2 }}>
          {icon}
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography noWrap sx={{ fontSize: 18, fontWeight: 800, color: INK }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography noWrap sx={{ fontSize: 13, color: MUTED }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {actions}
          <Tooltip title="Close">
            <IconButton onClick={onClose} disabled={busy} size="small">
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{ flex: 1, overflowY: 'auto', px: 2.5, pb: 2 }}>{children}</Box>
        {footer && <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, px: 2.5, py: 1.5, borderTop: `1px solid ${LINE}` }}>{footer}</Box>}
      </Box>
    </Drawer>
  );
}
